import { v4 as uuid } from 'uuid';

export default function (state, action) {
    if (!state) {
        state = {
            received: [],
            lastReceived: null,
        };
    }

    switch (action.type) {
        case 'PUSH_NOTIFICATION_RECEIVED':
            state = {
                ...state,
                received: [...state.received, pushReducer(null, action)],
                lastReceived: new Date().toISOString(),
            };
            break;
    }

    return state;
}

function pushReducer(state, action) {
    if (!state) {
        state = {};
    }

    switch (action.type) {
        case 'PUSH_NOTIFICATION_RECEIVED':
            state = {
                ID: uuid(),
                payload: action.payload,
                data: action.payload.data,
                read: false,
            };
    }

    return state;
}
